import { Typography } from '@mui/material'
import OtpInputField from '../../../UtilityComponents/OTPInputField/OTPInputField'
import "./ForgotPasswordOtpInputPage.scss";
import GGButton from '../../../CommonComponents/GGButton/GGButton';
import loaderLottie from '../../../../assets/lottie_animations/bubble-loader.json';
import Lottie from 'lottie-react';
import { PasswordResetFlowController } from '../hooks/usePasswordResetFlow';
import { OTP_LENGTH } from '../../../../enums/AuthFlowEnums';

interface ForgotPasswordOtpInputPageProps {
    flow: PasswordResetFlowController,
    onBack?: () => void
}

const ForgotPasswordOtpInputPage = ({ flow, onBack }: ForgotPasswordOtpInputPageProps) => {
  return (
    <div className='forgot-password-otp-input-page'>
        <Typography>Enter the 6 digit OTP sent to your email address : <b>{flow.email}</b> </Typography>
        <Typography variant='subtitle2'><i>Note: Please check your spam section as well for the password reset mail. </i></Typography>
        <OtpInputField onChangeOtp={flow.setOtp} length={OTP_LENGTH}/>
        <Typography variant='caption' sx={{color: 'red'}}>{flow.error}</Typography>
        {
            flow.isLoading ? 
            <Lottie className="loader-lottie" animationData={loaderLottie} loop={true}></Lottie> : 
            <div className='button-section'>
                <GGButton className='btn-secondary' onClick={onBack ?? flow.backToEmailStep}>
                    Go Back
                </GGButton>

                <GGButton className='btn-primary' onClick={flow.verifyOtp} disabled = {flow.otp.length !== OTP_LENGTH}>
                    Verify OTP
                </GGButton>
            </div>
        
        }
        <GGButton variant='text' disabled = {!flow.canResend || flow.isResending} onClick = {flow.resendOtp}> <Typography fontFamily={'arial'}> {flow.resendButtonText} </Typography>  </GGButton>
        
    </div>
  )
}

export default ForgotPasswordOtpInputPage